import api from '@/utils/api'

export function getNotificationList(params, options) {
  return api.post('/notification/list', params, options)
}

export function getUnreadCount(params, options) {
  return api.post('/notification/unread_count', params, options)
}

export function markNotificationRead(params, options) {
  return api.post('/notification/mark_read', params, options)
}

export function markAllNotificationsRead(params, options) {
  return api.post('/notification/mark_all_read', params, options)
}

// Notification Preferences
export function getNotificationPreferences(options) {
  return api.post('/notification/preferences/get', {}, options)
}

export function saveNotificationPreferences(params, options) {
  return api.post('/notification/preferences/save', params, options)
}
